import { Injectable, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { JobSchedulerError } from '@core/offers-types';

@Injectable({
  providedIn: 'root',
})
export class JobSchedulerErrorTextsService {
  private readonly i18n = inject(I18nService);

  public readonly errorTexts: {
    [key in JobSchedulerError]?: { content: string; tooltip: string };
  } = {
    [JobSchedulerError.InvalidStatus]: {
      content: this.i18n.translate('app.job_scheduler.schedule_info.error_status'),
      tooltip: this.i18n.translate('app.job_scheduler.schedule_info.error_status_tooltip'),
    },
    [JobSchedulerError.SlotsLimit]: {
      content: this.i18n.translate('app.job_scheduler.schedule_info.error'),
      tooltip: this.i18n.translate('app.job_scheduler.schedule_info.error_tooltip'),
    },
    [JobSchedulerError.MissingData]: {
      content: this.i18n.translate('app.job_scheduler.schedule_info.error'),
      tooltip: this.i18n.translate('app.job_scheduler.schedule_info.error_missing_data_tooltip'),
    },
    [JobSchedulerError.MissingRequisition]: {
      content: this.i18n.translate('app.job_scheduler.schedule_info.error'),
      tooltip: this.i18n.translate(
        'app.job_scheduler.schedule_info.error_missing_requisition_tooltip',
      ),
    },
    [JobSchedulerError.LocationsLimitExceeded]: {
      content: this.i18n.translate('app.job_scheduler.schedule_info.error'),
      tooltip: this.i18n.translate(
        'app.job_scheduler.schedule_info.error_locations_limit_exceeded_tooltip',
      ),
    },
  };
}
